export const eventSeriesAttributes = `
  id
  name
  status
  hostType
  user {
    id
    displayName
    username
    summary
    avatar {
      small {
        url
      }
      med {
        url
      }
    }
  }
  group {
    id
    name
    slug
    summary
    image {
      filename
    }
    city {
      id
      name
    }
    verified
    public
  }
`;
